export const displayedText = (node: Node) => {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent ?? '';
  if (!(node instanceof HTMLElement) || node.hidden || node.getAttribute('aria-hidden') === 'true') return '';
  if (node.tagName === 'STYLE') return '';

  const style = getComputedStyle(node);

  if (style.display === 'none' || style.visibility === 'hidden') return '';
  if (node instanceof HTMLInputElement) return ['hidden', 'checkbox', 'radio'].includes(node.type) ? '' : node.value;
  if (node instanceof HTMLTextAreaElement) return node.value;
  if (node.tagName === 'BR') return '\n';

  const text = Array.from(node.childNodes, displayedText).join('') as string;

  return node.matches('p, h6') ? `${text}\n` : text;
};
